<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2">
            <v-container>
                <!-- header info -->
                <v-row class="pa-4 pb-0">
                    <h3>Select users for task</h3>
                </v-row> 
                <v-row class="pa-4 pb-0">
                    <h5>{{ taak_code }} : {{ taak_oms }}</h5>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail/>
                    </v-col>
                    <v-col cols="6">
                        <v-checkbox v-model="active" label="Active only" @change="filterSelect"></v-checkbox>
                    </v-col>
                </v-row> 
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="px-0" >
                            <ul class="ul_style">
                                <li>
                                    <v-data-table 
                                        dense 
                                        hide-default-footer
                                        show-select
                                        return-object

                                        v-model="selected_users"

                                        :headers="getHeaders()" 
                                        :search="search"
                                        :items="filter_users"
                                        item-key="gebr_code"
                                        :disable-pagination=true>
                                    </v-data-table>
                                </li>
                            </ul>
                        </v-card> 
                    </v-col>
                </v-row> 
                <v-row class="pa-4 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="pr-5" small v-on:click="saveSelect">Save</v-btn>
                    &nbsp;
                    <v-btn color="primary" small v-on:click="closeSelect">Close</v-btn> 
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
        },             
        data() {
            return {
                taak_encrid: "",
                taak_code: "",
                taak_oms: "",
                search: "",
                active: false,
                all_users: [],
                filter_users: [],
                selected_users: [],
                dialog: false,
            }
        },
        methods: {  
            getTaakUser() {
                this.$axios.post("ares/json/ares/syst/authorization/getTaakUser.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getTaakUser"
                    },
                    getTaakUser: {
                        taak_encrid: this.taak_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.dialog = false;
                    } else {
                        this.all_users = res.data.getTaakUser;

                        this.selected_users = [];
                        for (let i = 0; i < this.all_users.length; i++) {
                            if (this.all_users[i].gebr_authorized) {
                                this.selected_users.push(this.all_users[i]);  
                            }           
                        }
                        this.filterSelect();
                        this.dialog = true;
                    }
                });
            },    
            openSelect(taak) {
                this.taak_encrid = taak.taak_encrid;
                this.taak_code = taak.taak_code;
                this.taak_oms = taak.taak_oms;

                // Clear previous values
                this.search = "";
                this.all_users = [];
                this.selected_users = [];
                this.getTaakUser();
            },
            saveSelect() {
                let selection = [];
                for (let i = 0; i < this.selected_users.length; i++) {
                    selection.push(this.selected_users[i].gebr_code);         
                }                
                this.$axios.post("ares/json/ares/syst/authorization/updTaakUser.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updTaakUser"
                    },
                    updTaakUser: {
                        taak_encrid: this.taak_encrid,
                        selected_users: selection,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        // Users updates, update parent & leave dialog
                        this.$emit("updateData"); 
                        this.dialog = false;
                    }
                });
            },
            closeSelect() {
                this.dialog = false;
            },
            getHeaders() {
                return [
                    { text: "User", value: "gebr_code", sortable: true},
                    { text: "Name", value: "gebr_naam", sortable: false},
                    { text: "Actief", value: "gebr_actief", sortable: false},
                ];
            },
            filterSelect() {
                if (this.active) {
                    this.filter_users = [];
                    for (let i = 0; i < this.all_users.length; i++) {
                        if (this.all_users[i].gebr_actief) {
                            this.filter_users.push(this.all_users[i]);  
                        }           
                    }                   
                } else {
                    this.filter_users = this.all_users;
                }
            }            
        },
    }

</script>

<style scoped>
    .row-pointer {
      cursor: pointer;
    }
    .button-margin-lr{
        margin-left: 4px;
        margin-right: 4px;
    }
    .button-margin-l{
        margin-left: 4px;
    }  
    .button-margin-r{
        margin-right: 6px;
    }  
    .gridbutton:hover{
        border: 1px solid rgba(169, 169, 169, 1) !important;
    }

	.flex{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
    .ul_style {
        list-style-type: none;
        /* Remove bullets */
        padding: 0;
        /* Remove padding */
        margin: 0;
        /* Remove margins */
        height: 315px;
        overflow-y: auto;
    }
</style>